module.exports = __webpack_public_path__ + "img/EASL2024.2334a56d.jpg";